var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"QRCodeShow"},[_c('div',{ref:"qrcode",staticStyle:{"display":"inline-block"},attrs:{"id":("qrcode" + _vm.randomTime)}}),_c('div',{staticClass:"down-title"},[_vm._v(" "+_vm._s(_vm.qrCodeIp)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }